export default __webpack_public_path__ + "static/media/ryan.e8c16eb4.jpg";